import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DrawerLayout from '../shared/DrawerLayout';
import FuelTransactionDrawerBody from './FuelTransactionDrawerBody';
import {
  closeFuelTransactionDrawerAndSetQueries,
  selectViewMode,
  selectViewType,
} from '../../redux/store/ui/common';
import { selectSelectedFuelTransaction } from '../../redux/store/userData/fuelTransactions';
import NestedDrawer from '../shared/NestedDrawer';
import { ViewMode } from '../../hooks/viewMode';
import { ViewType } from '../../hooks/useViewType';

const FuelTransactionDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const selectedFuelTransaction = useSelector(selectSelectedFuelTransaction);
  const viewMode = useSelector(selectViewMode);
  const viewType = useSelector(selectViewType);

  const handleOnClose = () => {
    dispatch(closeFuelTransactionDrawerAndSetQueries());
  };

  return (
    selectedFuelTransaction && (
      <DrawerLayout
        visible={selectedFuelTransaction !== null}
        title={selectedFuelTransaction?.id!}
        body={<FuelTransactionDrawerBody />}
        nestedDrawers={
          <>
            {(viewMode !== ViewMode.VEHICLE ||
              viewType === ViewType.TIME_TABLE) && (
              <NestedDrawer name="carEdit" />
            )}
            {viewMode !== ViewMode.SHARE && <NestedDrawer name="trip" />}
            {viewMode !== ViewMode.USERS && <NestedDrawer name="users" />}
          </>
        }
        onReload={undefined}
        onClose={handleOnClose}
      />
    )
  );
};

export default FuelTransactionDrawer;
